<h2 class="mb-3" *ngIf="data.text_title">{{ data.text_title }}</h2>
<p class="richtext-wrapper" [innerHTML]="safeHtml"></p>
